/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default $ => css`
  .form-tabs {
    position: relative;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    margin-top: 1rem;

    > .nav-item {
      position: relative;
      display: flex;
      width: auto;

      &.add-button {
        background-color: white;
      }

      > .nav-link {
        white-space: nowrap;

        .remove-btn {
          flex: 0 0 32px;
          padding-left: 6px;
          padding-right: 6px;
          font-weight: bold;
          font-size: 0.7rem;
          margin-left: 15px;
          margin-top: -3px;
          padding-top: 3px;
          padding-bottom: 3px;
        }
      }
    }
  }

  .form-tabs.sticky-tab-nav,
  .form-grouped-tabs.sticky-tab-nav {
    position: sticky;
    top: calc(${$.navbarHeight} + var(--form-sticky-header-height, 0px));
    z-index: 50;
    padding-top: 8px;
    background-color: ${$.white};
  }

  /* AnimateHeight sets overflow:hidden via inline style on BOTH the outer wrapper
     (.animate-height) and the inner content div (.auto-content). Both must be
     overridden so position:sticky on descendant tab navs can reach the scroll container. */
  .animate-height:has(.form-grouped-tabs.sticky-tab-nav),
  .animate-height:has(.form-tabs.sticky-tab-nav) {
    overflow: visible !important;
  }
  .animate-height:has(.form-grouped-tabs.sticky-tab-nav) > .auto-content,
  .animate-height:has(.form-tabs.sticky-tab-nav) > .auto-content {
    overflow: visible !important;
  }

  .borderless > .animate-height > .auto-content > fieldset > .object-field-tabs {
    > .form-tab-content {
      border-width: 0;
    }
  }

  .form-tab-content {
    border: 2px solid ${$.primaryMain};
    padding: 15px 32px 15px 15px;
    border-radius: 5px;
    height: auto !important;
  }

  .borderless.form-tab-content {
    border: none;
  }

  .object-field-template-footer {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(1px, 1fr));
    justify-content: space-between;

    .object-field-template-footer-section {
      display: flex;
      gap: 8px;
      padding-left: 16px;
      padding-right: 16px;

      &:last-of-type {
        justify-content: flex-end;
      }

      .nav-tabs {
        border-width: 0 !important;
      }
    }

    .object-field-template-footer-spacer {
      justify-self: center;
    }
  }

  .object-field-template-footer:not(.card-footer) {
    border-top: 1px solid #f5f5f5;
    padding-top: 16px;
  }

  .form-tabs.form-tabs-wrap {
    flex-wrap: wrap;

    .nav-item {
      flex: 1;

      a.nav-link {
        width: 100%;
        text-align: center;
      }
    }
  }
`;
